// extracted by mini-css-extract-plugin
module.exports = {"icon":"components-Tombstone-TombstoneComponents-EditIcon-EditIcon__icon--3UuJI"};